module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1048-d313897eb3ec312fb0f043aedfb14bba.png";